/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminEbayAccountSetup,
    AdminEbayAccountSetupFromJSON,
    AdminEbayAccountSetupFromJSONTyped,
    AdminEbayAccountSetupToJSON,
} from './AdminEbayAccountSetup';

/**
 * 
 * @export
 * @interface AdminEbayAccount
 */
export interface AdminEbayAccount {
    /**
     * 
     * @type {string}
     * @memberof AdminEbayAccount
     */
    connectedAt: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEbayAccount
     */
    connectedByName: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEbayAccount
     */
    ebayUserId: string;
    /**
     * ReconnectRequiredAt: since when eBay refuses the stored sign-in (expired or
     * revoked, e.g. after a password change); null while it works.
     * @type {string}
     * @memberof AdminEbayAccount
     */
    reconnectRequiredAt?: string;
    /**
     * RefreshTokenExpiresAt: after it the account has to be connected again (eBay gives 18 months).
     * @type {string}
     * @memberof AdminEbayAccount
     */
    refreshTokenExpiresAt: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminEbayAccount
     */
    scopes: Array<string>;
    /**
     * Setup is null until Set up has created the business policies and the inventory location.
     * @type {AdminEbayAccountSetup}
     * @memberof AdminEbayAccount
     */
    setup?: AdminEbayAccountSetup;
    /**
     * 
     * @type {string}
     * @memberof AdminEbayAccount
     */
    username: string;
    /**
     * VerifiedAt is the last time the stored sign-in worked.
     * @type {string}
     * @memberof AdminEbayAccount
     */
    verifiedAt?: string;
}

export function AdminEbayAccountFromJSON(json: any): AdminEbayAccount {
    return AdminEbayAccountFromJSONTyped(json, false);
}

export function AdminEbayAccountFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminEbayAccount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'connectedAt': json['connectedAt'],
        'connectedByName': json['connectedByName'],
        'ebayUserId': json['ebayUserId'],
        'reconnectRequiredAt': !exists(json, 'reconnectRequiredAt') ? undefined : json['reconnectRequiredAt'],
        'refreshTokenExpiresAt': json['refreshTokenExpiresAt'],
        'scopes': json['scopes'],
        'setup': !exists(json, 'setup') ? undefined : AdminEbayAccountSetupFromJSON(json['setup']),
        'username': json['username'],
        'verifiedAt': !exists(json, 'verifiedAt') ? undefined : json['verifiedAt'],
    };
}

export function AdminEbayAccountToJSON(value?: AdminEbayAccount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'connectedAt': value.connectedAt,
        'connectedByName': value.connectedByName,
        'ebayUserId': value.ebayUserId,
        'reconnectRequiredAt': value.reconnectRequiredAt,
        'refreshTokenExpiresAt': value.refreshTokenExpiresAt,
        'scopes': value.scopes,
        'setup': AdminEbayAccountSetupToJSON(value.setup),
        'username': value.username,
        'verifiedAt': value.verifiedAt,
    };
}

